/**
 * 한국 시각 기준 날짜 문자열(YYYY-MM-DD). (2026-09-28, I-78 2차 L2)
 *
 * 🔴 toISOString().slice(0, 10) 을 쓰지 않는다
 *   toISOString 은 UTC 라 한국 시각 00:00~08:59 에는 **어제 날짜**가 나온다.
 *   매매일지의 기간 끝(to)이 어제가 되어, 오늘 새벽에 체결된 미국장 거래가 "최근 30일" 에서 빠졌다.
 *   서버의 날짜는 전부 KST 다(DateUtils) — 화면도 KST 로 잘라야 둘이 같은 날을 가리킨다.
 *
 * sv-SE 로케일은 날짜를 ISO 모양(2026-09-28)으로 찍는다. 시간대만 서울로 지정한다.
 *
 * 공유 영역(lib/)이 아니라 trading 안에 둔 이유 — 쓰는 곳이 trading 세 곳뿐이다(stockApi · PaperPage · LadderGuideSection 2026-10-05).
 * 다른 도메인이 필요해지면 lib/format.ts 로 옮긴다.
 */
export function kstDateString(date: Date = new Date()): string {
  return date.toLocaleDateString('sv-SE', { timeZone: 'Asia/Seoul' });
}
